import { NgModule } from '@angular/core';
import { Routes, RouterModule, UrlMatchResult, UrlSegment } from '@angular/router';

import { canActivateSocial } from '../../core/guards/social-guard.service';

import { GuestPageComponent } from './guest-page/guest-page.component';
import { SocialResolverService } from './services/social-resolver.service';
import { WaitingRoomComponent } from './waiting-room/waiting-room.component';
import { EventCountdownPageComponent } from '../social-events/pages/event-countdown/event-countdown-page.component';

function uuidMatcher(url: UrlSegment[]): UrlMatchResult | null {
  const uuidRegex = /\b[0-9a-f]{8}\b-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-\b[0-9a-f]{12}\b/;
  if (url.length !== 1) {
    return null;
  }
  const [segment] = url;
  return segment.path.match(uuidRegex)
    ? {
        consumed: url,
        posParams: {
          id: segment,
        },
      }
    : null;
}

const routes: Routes = [
  {
    path: 'guest',
    component: GuestPageComponent,
  },
  {
    path: 'connected-room/:sid',
    component: WaitingRoomComponent,
    resolve: {
      social: SocialResolverService,
    },
    canActivate: [canActivateSocial],
  },
  {
    path: 'connected-room/:sid/:id',
    component: WaitingRoomComponent,
    resolve: {
      social: SocialResolverService,
    },
    canActivate: [canActivateSocial],
  },
  {
    path: 'events/:id/countdown',
    component: EventCountdownPageComponent,
  },

  // deprecated, legacy route support
  {
    path: 'room/:id',
    component: WaitingRoomComponent,
    resolve: {
      social: SocialResolverService,
    },
    canActivate: [canActivateSocial],
  },
  // deprecated, legacy route support
  {
    matcher: uuidMatcher,
    redirectTo: 'room/:id',
  },
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forChild(routes)],
})
export class SocialRoutingModule {}
